// from general.js
/* global dcAnalytics */
// from JSP?
/* global teacherPageInfo */


function trackTeacherPageStatus() {
    let projectStatus;
    if (typeof teacherPageInfo !== 'undefined' && teacherPageInfo.stats.numActiveProjects > 0 && teacherPageInfo.stats.numFundedProjects > 0) {
        projectStatus = 'yes live and yes funded';
    } else if (typeof teacherPageInfo !== 'undefined' && teacherPageInfo.stats.numActiveProjects > 0) {
        projectStatus = 'yes live and no funded';
    } else if (typeof teacherPageInfo !== 'undefined' && teacherPageInfo.stats.numFundedProjects > 0) {
        projectStatus = 'no live and yes funded';
    } else if (typeof teacherPageInfo !== 'undefined') {
        projectStatus = 'no live and no funded';
    } else {
        projectStatus = 'unknown';
    }

    dcAnalytics.track('Teacher page status - ' + projectStatus);
    dcAnalytics.trackEventGANonInteraction([pageName, 'status', projectStatus]);
}

$(document).ready(function () {
    trackTeacherPageStatus();
});
